import React from "react";
import { useTranslation } from "react-i18next";

import { Box } from "@mui/material";

import css from "@/pages/general-settings/GSuite/ServiceAccount.module.css";
import { GmailServiceAccountStatus } from "@/pages/general-settings/GSuite/gmailServiceAccountStatus";

const getClassNameFromStatus = (status: GmailServiceAccountStatus) => {
  if (status === GmailServiceAccountStatus.AVAILABLE) return css.green;
  if (status === GmailServiceAccountStatus.UNAVAILABLE) return css.red;
  return css.gray;
};

interface ServiceAccountProps {
  status: GmailServiceAccountStatus;
}

export function ServiceAccount({ status }: ServiceAccountProps) {
  const { t } = useTranslation();

  const getTranslatedStatus = () => {
    switch (status) {
      case GmailServiceAccountStatus.AVAILABLE:
        return t("Available");
      default:
        return t("Not available - action required from Mantra staff");
    }
  };

  return (
    <Box>
      <span className={getClassNameFromStatus(status)}>
        {getTranslatedStatus()}
      </span>
    </Box>
  );
}
